import { CDN_IMG_BASE } from "@/config";
import { getApiBase, getStoredPlatformId, PLATFORM_JQ18 } from "@/utils/apiPlatform";
export function resolveCdnUrl(url) {
    if (url == null || url === "")
        return "";
    const u = String(url);
    if (u.startsWith("http://") || u.startsWith("https://"))
        return u;
    if (getStoredPlatformId() === PLATFORM_JQ18 && (u.startsWith("/file/") || u.startsWith("/oss/")))
        return `${getApiBase()}${u.startsWith("/") ? "" : "/"}${u}`;
    const base = String(CDN_IMG_BASE || "").replace(/\/$/, "");
    return `${base}${u.startsWith("/") ? "" : "/"}${u}`;
}
